<header id="header" class="fixed-top">
  <div class="container-fluid d-flex align-items-center" style="padding-right:0px;">
    <a href="/" class="logo mr-auto scrollto"><img src="../../assets/images/SFI-Compliance_New.png"
        alt="SFI Compliance, Inc" class="img-fluidforlogo"></a>

    <nav class="nav-menu d-none d-lg-block">
      <div id="topbar" class="d-none d-lg-flex align-items-center ml-4">
        <div class="contact-info mr-auto">
          <ul>
            <li><i class="fa fa-envelope"></i><a
                href="mailto:customerservice@sfisafety.com">customerservice@sfisafety.com</a></li>
            <li><i class="fa fa-phone"></i> 1-800-727-5051</li>
            <!-- <li><i class="fa fa-clock-o"></i>8:00 AM - 4:30 PM</li> -->
          </ul>
        </div>
        <div class="cta" style="margin-right: 5px;">
          <a href="https://sfisafetyapp.com" target="_blank" class="scrollto">SFI Safety App Login</a>
        </div>
      </div>

      <ul id="mnu" style="background: #032d57;border-bottom-right-radius: 40px;">
        <div class="menu_orange_section {{homeclass}}" id="mnuorange" style="background: #032d57;margin-right: -33px;">
        </div>
        <li class="{{Home}}" (click)="topposition()"><a href="/" [routerLink]="['/']">HOME</a></li>
        <li class="drop-down"><a style="cursor: pointer;">ABOUT</a>
          <ul>
            <li (click)="topposition()"><a href="/ourcompany" [routerLink]="['/ourcompany']">OUR COMPANY</a></li>
            <li (click)="topposition()"><a href="/ourteam" [routerLink]="['/ourteam']">OUR TEAM</a></li>
          </ul>
        </li>
        <li class="{{SafetyProgram}}" (click)="topposition()"><a href="/safetyprogram"
            [routerLink]="['/safetyprogram']">SAFETY PROGRAM</a></li>
        <li class="{{SafetyTraining}}" (click)="topposition()"><a href="/safetytraining"
            [routerLink]="['/safetytraining']">SAFETY TRAINING</a></li>
        <li class="{{LiveEvents}}" (click)="topposition()"><a href="/livetrainings" [routerLink]="['/livetrainings']">LIVE EVENTS</a></li>
        <li class="drop-down"><a style="cursor: pointer;">INSPECTIONS</a>
          <ul>
            <li (click)="topposition()"><a href="/safetyinspection" [routerLink]="['/safetyinspection']">ON-SITE
                INSPECTIONS</a></li>
            <li (click)="topposition()"><a href="/dms" [routerLink]="['/dms']">SFI SAFETY APP</a></li>
            <li (click)="topposition()"><a href="/osha" [routerLink]="['/osha']">OSHA Assistance</a></li>
          </ul>
        </li>
        <li class="{{Contact}}" (click)="topposition()"><a href="/contact" [routerLink]="['/contact']">CONTACT SFI</a>
        </li>
        <!-- <li class="{{Careers}}" (click)="topposition()"><a href="/careers" [routerLink]="['/careers']">OPPORTUNITIES</a>
        </li> -->
        <li class="{{Blog}}" (click)="topposition()" style="margin-right: 7px;"><a href="/blog"
            [routerLink]="['/blog']">SFI SAFETY BLOG</a></li>

        <li class="{{Blog}}" id="client" (click)="topposition()" style="margin-right: 7px;"><a href="https://dms.sficompliance.com"
             target="_blank" >LOGIN</a></li>

        <!-- <li class="{{Blog}}" id="client" (click)="topposition()" style="margin-right: 7px;"><a href="/faq"
              [routerLink]="['/faq']">FAQ</a></li> -->
      </ul>

    </nav>
  </div>

</header>